import { Component, computed, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterModule, Router as NgRouter } from '@angular/router';
import { UiModule } from '@components/ui/ui-module';
import { Card as CardM } from '@models/card.model';
import { Card } from '@services/card.service';
import { Router } from '@services/route.service';

@Component({
  selector: 'lgb-card-search',
  imports: [
    RouterModule,
    FormsModule,
    UiModule
  ],
  templateUrl: './card-search.html',
  styleUrl: './card-search.css',
})
export class CardSearch {
  //services
  readonly cardS=inject(Card);
  readonly router=inject(Router);
  readonly ngRouter=inject(NgRouter);
  readonly route=inject(ActivatedRoute);

  //data
  readonly results=signal<CardM[]>([]);
  readonly qSearch=signal<string>(null);
  readonly autoLoad=signal(false);
  readonly currentPage=signal(0);

  //ui
  readonly loading=signal(false);
  readonly length: number=15;
  readonly backTo=computed(() => {
    //const tree=this.ngRouter.parseUrl(this.ngRouter.url);
    const tree=this.ngRouter.createUrlTree([], {
      queryParams: {q: this.qSearch(), page: this.currentPage()},
      queryParamsHandling: 'replace',
    });
    return this.ngRouter.serializeUrl(tree);
  });

  constructor(){
    this.route.queryParamMap
      .subscribe(params => {
        if(params.get('q')){
          this.qSearch.set(params.get('q'));
          if(params.get('page'))
            this.currentPage.set(Number(params.get('page')));
          this.autoLoad.set(true);
        }
      });
  }

  getSearch$(){
    return (q: string, start: number, length: number) => this.cardS.searchCards(q, start, length);
  }
} 
